import { createRouter, createWebHistory } from 'vue-router'
import LocalStoreAPI from "@/utils/localStoreUtil";

const routes = [];

export default function setUpRouter(app, useMain) {
    const useStoreMain = useMain();

    // 访问根路由跳转首页
    routes.push({
        path: '/',
        redirect: '/home/homepage'
    });
    // 访问/home路由跳转首页
    routes.push({
        path: '/home',
        redirect: '/home/homepage'
    });
    // 登录页
    routes.push({
        path: '/login',
        redirect: '/login/type=login'
    });
    // 404
    routes.push({
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        meta: { title: "Not Found" },
        component: () => import('@/components/NotFound.vue')
    });

    let token = LocalStoreAPI.get("ACCESS_TOKEN");
    let userInfo = LocalStoreAPI.getdecrypt("USER_INFO", token);
    console.log("路由页面获取用户信息:", userInfo)
    useStoreMain.setUserInfo(userInfo);
    const menuItem = useStoreMain.getMenuItem;

    // 动态注册路由
    getRouter(menuItem);

    // 创建路由实例
    const router = createRouter({
        history: createWebHistory(),
        routes,
    })

    // 全局路由守卫
    router.beforeEach((to, from, next) => {
        document.title = to.meta.title || '结构计算网';
        next();
    });

    // 挂载路由
    app.use(router)
};


// 注册路由
function getRouter(menuItem) {
    console.log("动态注册路由", menuItem)
    menuItem.forEach(item => {
        // 一级路由
        let routerItem = {
            name: item.name,
            path: item.path,
            meta: { title: item.title },
            component: () => import(`@/views/${item.component}.vue`),
            children: []
        };

        // 二级路由
        item.children.forEach(childrenItem => {
            let router = {
                path: childrenItem.path,
                name: childrenItem.name,
                meta: { title: childrenItem.title },
                component: () => import(`@/views/${childrenItem.component}.vue`),
                children: []
            };
            routerItem.children.push(router)
        });

        routes.push(routerItem);
    });
};
